import AboutSection from '../components/AboutSection.tsx';
import CTASection from '../components/CTASection.tsx';
import FAQSection from '../components/FAQSection.tsx';
import HeroSection from '../components/HeroSection.tsx';
import HowItWorksSection from '../components/HowItWorksSection.tsx';
import MedicalSpecialtiesSection from '../components/MedicalSpecialtiesSection.tsx';
import QualityPrivacySection from '../components/QualityPrivacySection.tsx';
import ServicesSection from '../components/ServicesSection.tsx';
import TargetAudienceSection from '../components/TargetAudienceSection.tsx';
import WhyChooseUsSection from '../components/WhyChooseUsSection.tsx';

function Home() {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <MedicalSpecialtiesSection />
      <WhyChooseUsSection />
      <HowItWorksSection />
      <CTASection />
      <TargetAudienceSection />
      <QualityPrivacySection />
      <FAQSection />
    </>
  );
}

export default Home;
